module.exports = __webpack_public_path__ + "img/license.316a9f2b.png";